import { render, staticRenderFns } from "./TablexCheck.vue?vue&type=template&id=188cbbba&scoped=true&"
import script from "./TablexCheck.vue?vue&type=script&lang=js&"
export * from "./TablexCheck.vue?vue&type=script&lang=js&"
import style0 from "./TablexCheck.vue?vue&type=style&index=0&id=188cbbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188cbbba",
  null
  
)

export default component.exports